<template>
    <div v-if="userStore.vipAvailable" class="container" @click="onClickCard" :class="{ 'pop-animate': isPopping }">
        <div class="card_content">
            <van-row>
                <van-col span="5" class="crown">
                    <div class="vip_num">V{{ currentLevel }}</div>
                    <img src="@/assets/profile/personal_icon_vip.png" alt="">
                    <span>{{ $t('profile.apostate') }}</span>
                </van-col>
                <van-col span="18" offset="1">
                    <van-row class="right_content">
                        <van-col span="23" class="text_icon">{{ isVIPLevelEnd ? $t('vip.highestLevelAchived') : $t('profile.followVIP1', { level: nextLevel }) + betMin }}
                            <img src="@/assets/profile/arrow_right_white45.png" alt="">
                        </van-col>
                        <van-col span="24">
                            
                            <div class="bar">
                                <div class="progress"
                                    :style="{ width: betTotal / betMin < 1 ? betTotal * 100 / betMin + '%' : '100%' }">
                                </div>
                                <div class="progress-end-dot"
                                    :style="{ left: `calc(${betTotal * 100 / betMin}% - 6px)` }">
                                </div>
                            </div>
                        </van-col>
                        <van-col span="24" class="progress_bar">{{ betTotal }} / {{ betMin }}</van-col>
                    </van-row>

                </van-col>
            </van-row>
        </div>

    </div>
</template>

<script setup lang="ts">
import { useUserStore } from '@/stores/user'
import { clickOnCard } from '@/view/profile/supportScript'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
const router = useRouter()
const userStore = useUserStore()
const isPopping = ref(false)
const currentLevel = computed(() => userStore.VIPData.currentLevel)
const betTotal = computed(() => userStore.VIPData.cumulativeBetTotal)
const betMin = computed(() => userStore.VIPData.bet_min)
const nextLevel = computed(() => userStore.VIPData.nextLevel)
const isVIPLevelEnd =  computed(() => userStore.isHighestVIPlevel)

const onClickCard = () => clickOnCard(router, isPopping, '/sd-vip')
</script>
<style scoped>
.container {
    padding: 0px 15px;
}

.card_content {
    padding: 20px 15px;
    border-radius: 10px;
    background-image: radial-gradient(circle at 0% 0%, rgba(123, 89, 54, 0.75) 0%, rgba(123, 89, 54, 0.0) 30%), radial-gradient(circle at 89% 100%, rgba(110, 80, 50, 0.75) 0%, rgba(110, 80, 50, 0.00) 18%), linear-gradient(74deg, #3A2B1E 0%, #3B2C1F 100%);
}

.crown {
    color: #fff;
    display: flex;
    text-align: center;
    flex-direction: column;
    position: relative;
}

.crown img {
    width: 65px;
}

.crown span {
    padding-top: 10px;
}


.text_icon img {
    width: 12px;
    padding-left: 5px;
}

.text_icon {
    display: flex;
    align-items: center;
    justify-content: right;
    color: #fff;
    display: flex;
    justify-content: right;
    font-size: 11px;
    padding-top: 10px;
}

.bar {
    position: relative;
    background: #12151A;
    border-radius: 20px;
    margin-top: 25px;
    font-size: 13px;
    width: 100%;
    height: 20px;
}

.progress {
    background: #F0A853;
    border-radius: 20px;
    height: 20px;
}


.progress_bar {
    color: #fff;
    display: flex;
    text-align: center;
    justify-content: center;
    border-radius: 20px;
    margin-top: -18px;
    font-size: 13px;
    width: 100%;
    padding: 2px;
    z-index: 1;
}

.right_content {
    display: flex;
    flex-direction: column;
}

.vip_num {
    position: absolute;
    top: 14px;
    left: 38px;
    color: #000;
}

.pop-animate {
    animation: pop-scale 0.3s ease;
}

@keyframes pop-scale {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(0.9);
    }

    100% {
        transform: scale(1);
    }
}
</style>